export default {
    "series": null,
    "working_title": null,
    "colour": null,
}